import React, { useState, useEffect } from 'react';
import EventCard from './EventCard';

const EventList = ({ fetchEvents, title }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetchEvents();
        setEvents(response.data);
      } catch (err) {
        setError('Failed to load events. Please try again later.');
        console.error('Error fetching events:', err);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, [fetchEvents]);

  if (loading) {
    return <div style={styles.loading}>Loading events...</div>;
  }

  if (error) {
    return <div style={styles.error}>{error}</div>;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{title}</h2>
      {events.length === 0 ? (
        <p style={styles.noEvents}>No events available at the moment.</p>
      ) : (
        <div style={styles.eventsList}>
          {events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
  },
  title: {
    color: '#2c3e50',
    marginBottom: '2rem',
    textAlign: 'center',
  },
  eventsList: {
    display: 'flex',
    flexDirection: 'column',
  },
  loading: {
    textAlign: 'center',
    padding: '2rem',
    fontSize: '1.2rem',
    color: '#666',
  },
  error: {
    textAlign: 'center',
    padding: '2rem',
    fontSize: '1.2rem',
    color: '#e74c3c',
    backgroundColor: '#fdf2f2',
    border: '1px solid #f5c6cb',
    borderRadius: '4px',
    margin: '1rem',
  },
  noEvents: {
    textAlign: 'center',
    padding: '2rem',
    color: '#666',
    fontSize: '1.1rem',
  },
};

export default EventList;